if (process.env.NODE_ENV === 'production') {
  module.exports = require('./environment.prod.js');
} else {
  module.exports = require('./environment.dev.js');
}
